export default {
  getSolutionAttachment: (state) => state.solutionAttachment,
};
